
import React from "react";
import { components } from "react-select";

// Add this above your return statement or outside the component


export const CustomOption = (props: any) => {
  const { data } = props;
  const [showTooltip, setShowTooltip] = React.useState(false);

  return (
    <div
      style={{ position: "relative" }}
      onMouseEnter={() => data.isDisabled && setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <components.Option {...props} />

      {showTooltip && data.isDisabled && data.blockingMilestone && (
        <div
          style={{
            position: "absolute",
            left: "100%",
            top: "50%",
            transform: "translateY(-50%)",
            marginLeft: "8px",
            background: "#1a1a1a",
            color: "#fff",
            fontSize: "11.5px",
            fontWeight: 500,
            padding: "6px 10px",
            borderRadius: "6px",
            whiteSpace: "nowrap",
            zIndex: 9999,
            pointerEvents: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.18)",
          }}
        >
          {/* Arrow */}
          <div
            style={{
              position: "absolute",
              left: "-5px",
              top: "50%",
              transform: "translateY(-50%)",
              width: 0,
              height: 0,
              borderTop: "5px solid transparent",
              borderBottom: "5px solid transparent",
              borderRight: "5px solid #1a1a1a",
            }}
          />
          Complete <strong style={{ color: "#F8B71F" }}>"{data.blockingMilestone}"</strong> first
        </div>
      )}
    </div>
  );
};

